module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[14]135.dcae797.woff2";